import {
  isExist,
} from '@qx/utils/index';

// 计算单价
export const calCostPrice = ({
  cmMileageForm,
  incomeForm,
  carriageForm,
}) => {
  let priceEnum = Number(incomeForm.otherFormData.priceEnum);
  if (!isExist(priceEnum)) {
    priceEnum = 1;
    incomeForm.otherFormData.priceEnum = '1';
  }
  // 获取当前输入的单价
  let priceUnit = incomeForm.$refs.baseForm.getVal('priceUnit');

  if (!isExist(priceUnit) || isNaN(priceUnit)) {
    priceUnit = 0;
  }

  // 数量
  let num = 0;
  if (priceEnum === 1) {
    // 按车计算
    num = 1;
  } else if (priceEnum === 2) {
    // 按千克计算（获取当前输入的重量）
    const weight = carriageForm.$refs.baseForm.getVal('goodsWeight');
    num = Number(weight) * 1000;
  } else if (priceEnum === 3) {
    // 按方计算（获取当前输入的体积）
    const square = carriageForm.otherFormData.goodsVolume;
    num = square;
  } else if (priceEnum === 4) {
    // 按公里计算（获取当前输入的客户公里数）
    const cmMileage = cmMileageForm.$refs.baseForm.getVal('cmMileageNumber');
    num = cmMileage;
  } else if (priceEnum === 5) {
    // 按件计算（获取当前输入的计划数量）
    const goodsNumber = carriageForm.$refs.baseForm.getVal('goodsNumber');
    num = goodsNumber;
  } else if (priceEnum === 6) {
    // 按吨计算 （获取当前输入的吨）
    const weight = carriageForm.$refs.baseForm.getVal('goodsWeight');
    num = Number(weight);
  }

  if (!isExist(num) || isNaN(num)) {
    num = 0;
  }

  const costPrice = (priceUnit * num).toFixed(2);
  incomeForm.$refs.baseForm.setVal('estimateIncome', costPrice);
};
